"use client";

import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoicesOfSecurity() {
  const testimonials = [{
    quote: "Legacy Wealth Legal provided more than just documents; they gave our family a fortress. Their focus on wealth preservation rather than just probate was exactly what we needed.",
    name: "The Sterling Family",
    meta: "ESTATE PLANNING — PALM BEACH — JUNE 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_sterling_family.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_sterling_family.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_sterling_family.png-wvc-sizes",
    alt: "Portrait of a Florida family in a modern estate setting"
  }, {
    quote: "The asset protection strategies implemented by the firm have given me immense peace of mind. They understand the unique nuances of Florida law like no one else.",
    name: "Robert H. Vance",
    meta: "ASSET PROTECTION — MIAMI — MAY 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_robert_vance.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_robert_vance.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_robert_vance.webp-wvc-sizes",
    alt: "Portrait of a business owner in a professional setting"
  }, {
    quote: "Navigating revocable trusts felt daunting until we met the team at Legacy Wealth. They translated complex legalities into a clear roadmap for our children's future.",
    name: "Elena & Marcus Thorne",
    meta: "REVOCABLE TRUSTS — NAPLES — APRIL 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_thorne_couple.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_thorne_couple.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_thorne_couple.png-wvc-sizes",
    alt: "Portrait of a couple in a high-end residential environment"
  }, {
    quote: "Their approach to family safeguards and healthcare directives was both authoritative and deeply empathetic. We felt truly heard and protected.",
    name: "Dr. Julianna Rossi",
    meta: "FAMILY SAFEGUARDS — BOCA RATON — MARCH 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_julianna_rossi.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_julianna_rossi.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_julianna_rossi.png-wvc-sizes",
    alt: "Portrait of a professional woman in a modern office"
  }, {
    quote: "A legacy is more than money; it's a story. Legacy Wealth Legal helped us write ours with precision, ensuring our values are preserved for generations.",
    name: "The Montgomery Estate",
    meta: "WEALTH PRESERVATION — SARASOTA — FEBRUARY 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_montgomery_estate.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_montgomery_estate.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_montgomery_estate.webp-wvc-sizes",
    alt: "Architectural detail of a luxury Florida estate"
  }, {
    quote: "The 'Legacy Review' was eye-opening. We discovered vulnerabilities we never knew existed and addressed them before they could become problems.",
    name: "Jonathan & Sarah Wu",
    meta: "LEGACY REVIEW — ORLANDO — JANUARY 2024",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_wu_family.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_wu_family.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_wu_family.png-wvc-sizes",
    alt: "Portrait of a family in a sophisticated home setting"
  }, {
    quote: "Professionalism at its peak. The firm's focus on high-end wealth security is evident in every interaction and every piece of advice.",
    name: "Arthur Billington III",
    meta: "ASSET PROTECTION — CORAL GABLES — DECEMBER 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_arthur_billington.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_arthur_billington.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_arthur_billington.png-wvc-sizes",
    alt: "Portrait of a senior executive"
  }, {
    quote: "They don't just draft papers; they build vaults. Our family's privacy and court-avoidance goals were met with absolute technical mastery.",
    name: "The Kensington Trust",
    meta: "REVOCABLE TRUSTS — FORT LAUDERDALE — NOVEMBER 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_kensington_trust.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_kensington_trust.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_kensington_trust.png-wvc-sizes",
    alt: "Detail of a modern architectural structure"
  }, {
    quote: "The peace of mind knowing our children's trusts are structured correctly is invaluable. Legacy Wealth Legal is the gold standard in Florida.",
    name: "David & Claire Foster",
    meta: "FAMILY SAFEGUARDS — TAMPA — OCTOBER 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_foster_family.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_foster_family.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_foster_family.png-wvc-sizes",
    alt: "Portrait of a family in a coastal setting"
  }, {
    quote: "In a world of litigation, their asset protection strategies are a necessary shield. I recommend them to every business owner I know.",
    name: "Gregory St. James",
    meta: "ASSET PROTECTION — JUPITER — SEPTEMBER 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_gregory_stjames.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_gregory_stjames.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_gregory_stjames.png-wvc-sizes",
    alt: "Portrait of a confident professional"
  }, {
    quote: "The firm's story is one of excellence. They treated our estate planning with the reverence and detail it deserved.",
    name: "The DuPont Family",
    meta: "ESTATE PLANNING — VERO BEACH — AUGUST 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_dupont_family.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_dupont_family.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_dupont_family.png-wvc-sizes",
    alt: "Portrait of a multi-generational family"
  }, {
    quote: "Authoritative yet empathetic. They guided us through the complexities of Florida wealth law with grace and unmatched expertise.",
    name: "Lydia & Thomas Vance",
    meta: "WEALTH PRESERVATION — PONTE VEDRA — JULY 2023",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_vance_couple.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_vance_couple.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_vance_couple.png-wvc-sizes",
    alt: "Portrait of a couple in a sophisticated outdoor setting"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  const total = testimonials.length;
  const current = testimonials[activeIndex];
  const goPrev = () => setActiveIndex(prev => (prev - 1 + total) % total);
  const goNext = () => setActiveIndex(prev => (prev + 1) % total);
  const pad = (n: number) => n.toString().padStart(2, "0");
  return <section data-section-id="653" id="voices-of-security" className="relative py-32 px-6 md:px-12 lg:px-20 bg-background text-foreground">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="mb-16 md:mb-24 flex items-center gap-4"><div className="w-10 h-[1px] bg-primary" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/VoicesOfSecurity.tsx|sig:cz6krm" data-ast-start="8960" data-ast-end="9022"></div></div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5 relative">
            <div className="relative">
              <span aria-hidden="true" className="font-serif italic absolute -top-12 -left-4 md:-top-16 md:-left-8 select-none pointer-events-none leading-none" style={{
              fontSize: "8rem",
              fontWeight: 300,
              color: "var(--primary)",
              opacity: 0.2,
              zIndex: 2
            }}>
                &ldquo;
              </span>

              <div key={current.image} className="relative overflow-hidden animate-in fade-in duration-700 rounded-md" style={{
              aspectRatio: "4 / 5"
            }}>
                <img src={current.image} data-wvc-srcset={current.srcset} data-wvc-sizes={current.sizes} alt={current.alt} loading="lazy" decoding="async" className="h-full object-cover" style={{
                filter: "contrast(1.05) saturate(0.8) grayscale(0.2)"
              }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/Suburban-Home.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/Suburban-Home.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/Suburban-Home.png" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/image_b2443ee6.png" />
                <div aria-hidden="true" className="absolute inset-0 pointer-events-none mix-blend-overlay opacity-20" style={{
                backgroundImage: "radial-gradient(hsla(215, 45%, 10%, 0.15) 1px, transparent 1px)",
                backgroundSize: "4px 4px"
              }} />
                {}
                <div className="absolute top-4 left-4 w-4 h-4 border-t border-l border-primary" />
                <div className="absolute bottom-4 right-4 w-4 h-4 border-b border-r border-primary" />
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-center !bg-[rgba(29,40,58,1)] lg:col-span-7">
            <div className="mb-8">
              <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-secondary"></span>
            </div>

            <blockquote key={`quote-${activeIndex}`} className="animate-in fade-in duration-500 !not-italic text-primary !bg-[rgba(29,40,58,1)] !font-mono !text-center !text-6xl" style={{
            fontSize: "clamp(1.75rem, 2.5vw, 2.5rem)",
            fontWeight: 400,
            lineHeight: 1.3
          }}>KID'S PROTECTION PLANS</blockquote>

            

            <div key={`attr-${activeIndex}`} className="animate-in fade-in duration-500">
              <p className="!bg-[rgba(29,40,58,1)] !font-default !font-normal !text-[rgba(223,227,231,1)] !text-left !text-base" style={{
              fontSize: "1.25rem",
              fontWeight: 500
            }}><br />A Kid's Protection Plan is a comprehensive framework designed to safeguard your children’s well-being, care, and guardianship if you become incapacitated or pass away unexpectedly. Unlike a standard will, which primarily addresses asset distribution, this plan focuses on your child’s immediate and long-term care, including legal guardianship, medical decisions, and daily routines.<br /><br />Key Components:<br /><br />1.&nbsp; &nbsp; Legal Guardian Nomination: You can name both short-term and long-term guardians, ensuring your children are cared for by trusted individuals rather than someone appointed by a court.<br />2.&nbsp; &nbsp; Medical Authorizations: Allows designated adults to make emergency medical decisions for your child.<br />3.&nbsp; &nbsp; Caregiver Instructions: Detailed guidance on daily routines, allergies, preferences, and special needs.<br />4.&nbsp; &nbsp; Emergency ID Cards: Alerts authorities and first responders to your child’s guardianship plan, reducing delays and confusion during emergencies.<br />5.&nbsp; &nbsp; Legal Documents and Instructions: Provides clear, legally sound documentation to prevent children from being placed in the custody of Child Protective Services or strangers.<br /><br /><br /><br /><br /></p>
              <Link to="https://www.legacywealthlegal.kidsprotectionplan.com" newTab className="mt-2 font-mono uppercase cursor-pointer transition-opacity block !bg-[rgba(29,40,58,1)] text-primary !text-center !text-3xl hover:opacity-70" style={{
              fontSize: "12px",
              letterSpacing: "0.2em"
            }}>FIRST STEP FREE GUARDIANSHIP-CLICK TO GET STARTED</Link>
            </div>
          </div>
        </div>

        <div className="mt-20 md:mt-28 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="flex items-center gap-2 flex-wrap" role="tablist" aria-label="Testimonial pagination">
            {testimonials.map((t, i) => <Button key={i} data-index={i} variant="ghost" role="tab" aria-selected={i === activeIndex} aria-label={`Show testimonial ${i + 1}`} onClick={() => setActiveIndex(i)} className="p-2 -m-2 outline-none focus-visible:ring-2 focus-visible:ring-primary h-auto rounded-md">
                <span className="block transition-all duration-300" style={{
              width: i === activeIndex ? "40px" : "20px",
              height: "1px",
              backgroundColor: i === activeIndex ? "var(--primary)" : "var(--border)"
            }} />
              </Button>)}
          </div>

          <div className="flex items-center gap-6">
            

            <span aria-hidden="true" className="inline-block" style={{
            width: "1px",
            height: "16px",
            backgroundColor: "var(--border)"
          }} />

            
          </div>
        </div>
      </div>
    </section>;
}